module.exports = __webpack_public_path__ + "static/media/ask.f2ddb667.svg";